export const cultures = [
  {
    head: '愿景',
    title: '成为全球领先的智能化教练服务平台',
    description: '人工智能时代已经来临，爱问希望让所有企业管理者的智慧能够在一个平台上最大化的共享，任何管理问题都可以在爱问的平台上找到答案。',
    cover: require('../images/culture_vision.png'),
  },
  {
    head: '使命',
    title: '激发个人与组织的无限潜能',
    description: '爱问推崇由内而外的思维模式，相信P（绩效）=p（潜能）-i（干扰），通过教练技术帮助个人和组织明确目标、点燃心火、发挥优势，在不增加外在成本的情况下，通过减少干扰的方式激发个人和组织的潜能。',
    cover: require('../images/culture_mission.png'),
  },
  {
    head: '价值观',
    title: '成果导向  成就他人  推动改变',
    description: '体育教练的目标是获得名次，管理者的目标是达成绩效，爱问要求人人在岗位上都要贡献价值，创造成果。\n体育教练的任务是培养冠军，管理者的任务是培养人才，爱问的员工必须要有利他之心、有帮助他人成长的勇气和能力。\n知道做不到等于不知道，培训的目的就是改变，改变永远从自己开始，爱问永远在推动自己和客户的改变之路上前进。',
    cover: require('../images/culture_worth.png'),
  },
]

export const trainers = [
  { name: '季益祥', position: ['行动教练创始人'], photo: require('../images/man_jiyixiang.png') },
  { name: '蔡明', position: ['行动教练课程创始人'], photo: require('../images/man_caiming.png') },
  { name: '高煜东', position: ['国际行动教练协会认证讲师'], photo: require('../images/man_gaoyudong.png') },
  { name: '金律言', position: ['WIAC认证讲师'], photo: require('../images/man_jinlvyan.png') },
  { name: '戴维', position: ['行动教练核心讲师', '行动教练创始人'], photo: require('../images/man_daiwei.png') },
  { name: '朱莎', position: ['国际行动教练协会上海分会理事', '行动教练创始人'], photo: require('../images/man_zhusha.png') },
  { name: '徐华', position: ['行动教练联合创始人', '独角兽企业“沪江副总裁”'], photo: require('../images/man_xuhua.png') },
  { name: '吴静艳', position: ['国际行动教练协会认证讲师', '行动教练创始人'], photo: require('../images/man_wujingyan.png') },
  { name: '肖广', position: ['银行绩效提升专家', '行动教练创始人'], photo: require('../images/man_xiaoguang.png') },
  { name: '饶洛', position: ['行动教练联合创始人', '国际行动教练协会认证讲师'], photo: require('../images/man_raoluo.png') },
  { name: '宋城', position: ['国际行动教练协会北京分会理事', '埃里克森国际学院认证教练'], photo: require('../images/man_songcheng.png') },
  { name: '王芳', position: ['行动教练初阶课程9.0版认证讲师', '香港行动教练研究院特聘教授'], photo: require('../images/man_wangfang.png') },
  { name: '褚莉莉', position: ['国际行动教练协会上海分会理事', '行动教练认证讲师'], photo: require('../images/man_zhulili.png') },
  { name: '彭信之', position: ['国际行动教练协会认证讲师', '国家开放大学“网络培训中心”客座教授'], photo: require('../images/man_pengxunzhi.png') },
  { name: '薛晓峰', position: ['国际行动教练协会认证讲师', '爱问（上海）管理咨询有限公司合伙人'], photo: require('../images/man_xuexiaofeng.png') },
]

export const partners = [
  require('../images/partner_zgyh.png'),
  require('../images/partner_zggsyh.png'),
  require('../images/partner_zgjsyh.png'),
  require('../images/partner_zgpa.png'),
  require('../images/partner_zgrs.png'),
  require('../images/partner_zjsj.png'),
  require('../images/partner_gjdw.png'),
  require('../images/partner_zgsh.png'),
  require('../images/partner_zgyc.png'),
  require('../images/partner_alibaba.png'),
  require('../images/partner_zgyd.png'),
  require('../images/partner_zgdx.png'),
  require('../images/partner_zgdfhk.png'),
  require('../images/partner_shdt.png'),
  require('../images/partner_wxdt.png'),
]